/**
 * Created by Ning Jiang on 3/20/2019.
 */

import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";
import {TombstoneGameModuleConfig} from "../../TombstoneGameModuleConfig";
import {ReelAnimationState} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelAnimationState";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {TombstoneParsedGameData} from "../../server/data/TombstoneParsedGameData";

export class TombstoneSideReelController extends SpinReelController {


    private gameData:SpinParsedGameData;
    constructor(reelId:number) {
        super(reelId);
    }

    protected tryPlayNearWin(reelId:number):void {
        if(reelId !== this.reelId) {
            return;
        }

        if((this.hasNearWin() && this.currentState === ReelAnimationState.SPIN)) {

            if(!(this.gameData.mode === GameMode.NORMAL && (TombstoneGameModuleConfig.initData.buyFeatureName === "LUCKY_DRAW_BIG" || TombstoneGameModuleConfig.initData.buyFeatureName === "LUCKY_DRAW_SMALL"))) {
                this.playNearWin(reelId);
            }
        }
    }

    onGameDataParsed(data: SpinParsedGameData) {
        super.onGameDataParsed(data);

        this.gameData = data;
    }

    protected getNearWinStopDelay(reelId:number):number {


        if((TombstoneGameModuleConfig.gameData.wasFeatureBuy && this.gameData.mode === GameMode.NORMAL) && (TombstoneGameModuleConfig.initData.buyFeatureName === "SUPER_FREESPIN" || TombstoneGameModuleConfig.initData.buyFeatureName === "FREESPIN")) {
            return this.getFastSpinStopDelay(this.reelId);
            //return ReelController._reelStopDelays[reelId];
        }

        if(this.gameData.mode === GameMode.NORMAL && (TombstoneGameModuleConfig.initData.buyFeatureName === "LUCKY_DRAW_BIG" || TombstoneGameModuleConfig.initData.buyFeatureName === "LUCKY_DRAW_SMALL")) {
            //return ReelController._reelStopDelays[reelId];
            return this.getFastSpinStopDelay(this.reelId);
            //return [0, 0.2, 0.2, 0.2, 0][reelId];
        }


        return ReelController._reelNearWinStopDelays[reelId];
    }

    protected getNormalStopDelay(reelId: number): number {

        if((TombstoneGameModuleConfig.gameData.wasFeatureBuy && this.gameData.mode === GameMode.NORMAL) && (TombstoneGameModuleConfig.initData.buyFeatureName === "SUPER_FREESPIN" || TombstoneGameModuleConfig.initData.buyFeatureName === "FREESPIN")) {
            return this.getFastSpinStopDelay(this.reelId);
            //return ReelController._reelStopDelays[reelId];
        }

        if(this.gameData.mode === GameMode.NORMAL && (TombstoneGameModuleConfig.initData.buyFeatureName === "LUCKY_DRAW_BIG" || TombstoneGameModuleConfig.initData.buyFeatureName === "LUCKY_DRAW_SMALL")) {
            //return ReelController._reelStopDelays[reelId];
            return this.getFastSpinStopDelay(this.reelId);
            //return [0, 0.2, 0.2, 0.2, 0][reelId];
        }


        return super.getNormalStopDelay(reelId);
    }

    protected createNextSymbol(previousSymbol?:StateReelSymbol, init?:boolean):StateReelSymbol {
        const newSymbol:StateReelSymbol = super.createNextSymbol(previousSymbol, init);
        if(!init) {
            if(newSymbol.symName.indexOf("B") === -1) {
                if(this._reelPartAnimator.symbolsToAnimate[0].symName.indexOf("B") > -1) {
                    this._reelPartAnimator.symbolsToAnimate[0].parent.addChild(this._reelPartAnimator.symbolsToAnimate[0]);
                }
            }
        }

        return newSymbol;
    }
}